import { Component } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { ChassisService } from 'src/app/services/chassis/chassis.service';

@Component({
  selector: 'app-chassis',
  templateUrl: './chassis.component.html',
  styleUrls: ['./chassis.component.css']
})
export class ChassisComponent {
  chassisDocks: DocksModel[] = []
  dateInterval: any
  updateInterval: any

  timeTableIsVisible: boolean = false;

  private readonly DEFAULT_COLOR = '#FFF'
  private readonly ACTIVE_COLOR = '#3CB371'
  private readonly INACTIVE_COLOR = '#FF2340'

  Date = Date.now();

  constructor(private chassisService: ChassisService) { }

  ngOnInit() {
    this.updateData();

    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.chassisService.getChassisDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (response) => {
          this.chassisDocks = response.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }

  ngOnDestroy() {
    clearInterval(this.dateInterval);
    clearInterval(this.updateInterval);
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {

    const dock = this.chassisDocks.find((t) => t.id == docks);
    if (this.isDockValidAndActive(dock)) {
      switch (dock?.truck) {
        case 0:
          return this.DEFAULT_COLOR
        case 1:
          return this.ACTIVE_COLOR
        default:
          return "Valor no campo 'Truck' inválido"
      }
    } return this.INACTIVE_COLOR
  }

  private isDockValidAndActive(dock: any): boolean {
    return dock && dock.truck !== undefined && dock.status && dock.active == 1
  }

  // time-table control

  openPlanning() {
    this.timeTableIsVisible = !this.timeTableIsVisible
  }


}

